// extracted by css-extract-rspack-plugin
export default {"component":"Controls-module__component___z5fUs stats-Q-OE-Component-Controls","toggle":"Controls-module__toggle___KLWhQ","export":"Controls-module__export____0BFA"};